export {
  type ChildBase,
  type ValuesSpec,
  type Meta,
  type Trigger,
  type Action,
  type GeneralJsonTypeBase,
} from '@unicorn/sdui';

export const domen = process.env.API_URL;
export const domenUploadFile = process.env.IM_URL;

export const minInvocePrice = 1;
export const maxInvocePrice = 1000000;

export const rootToken = 'root-invoces';
export const invocesToken = 'invoces-index';

export const newInvocesToken = 'vertical-new-invoces';
export const existedInvocesToken = 'vertical-existed-invoces';
export const marketOrdersToken = 'vertical-market-orders';
export const deleteInvocesToken = 'delete-invoces';
export const noExistedInvocesToken = 'vertical-no-existed-invoces';

export const toEditToken = 'to-edit';
export const toReadonlyToken = 'to-readonly';
export const saveToken = 'to-save';
export const actionsToken = 'actions';

export const paymentTypesColors = {
  'waiting-for-payment': 'default',
  'price-clarification': 'warning',
  paid: 'success',
};

export const reloadSaveStatuses = {
  'saved-existed': 'saved-existed',
  'saved-new': 'saved-new',
  'save-delete': 'save-delete',
};
